<div class="glossary-container tab-content">
    <div class="card-column">


        <div class="card card-block">
            <div class="form-group col-xs-12">
                <input class="form-control" type="input" (keyup.enter)="searchGlossary()"[(ngModel)]="searchTerm">
                <div class="btn-group-sm">
                    <button class="btn btn-primary btn-sm" [disabled]="searching" (click)="searchGlossary()">Search</button>
                    <button class="btn btn-secondary btn-sm" [disabled]="searching" (click)="clearGlossary()">Clear</button>
                </div>
                <!--<div class="btn-group-sm">
                    <button class="btn btn-outline-primary btn-sm" [disabled]="searching" (click)="showSelected()">Highlight Selected Word</button>
                </div>-->
            <div class="card-text" *ngIf="searching">searching...</div>
            <div class="card-text" *ngIf="!searching && searchTerm !== '' && (searchTerm === lastSearchTerm) && (glossarySearchResult?.length === 0)">There is no entry for <em>{{searchTerm}}</em>. Add it if needed.</div>
            </div>
            <div class="form-group col-xs-12" *ngIf="linkTerm !== ''">
                <label class="form-label" for="linkTerm">Text phrase to link:</label>
                <input class="form-control" type="input" id="linkTerm" [(ngModel)]="linkTerm">
            </div>
        </div>
        <div *ngIf="glossarySearchResult" class="card-deck">
            <div *ngIf="!searching && glossarySearchResult?.length > 0" class="card card-header">
                <div >There {{glossarySearchResult.length == 1 ? 'is' : 'are'}} {{glossarySearchResult.length}} result{{glossarySearchResult.length == 1 ? '' : 's'}}:</div>
            </div>

            <div *ngFor="let glossaryInfo of glossarySearchResult; let idx = index" class="card-block">
                <glossary-editor-detail [idx]="idx"
                                        (saveWithLinkRequest)="saveLinkGlossaryEntry($event)"
                                        (updateRequest)="updateGlossaryEntry($event)"
                                        (deleteRequest)="deleteGlossaryEntry($event)"
                                        (makeDefinitionRequest)="makeDefinition($event)"
                                        [glossaryInfo]="glossaryInfo"
                                        [saveInProgress]="saveInProgress"
                                        [selectedWord]="selectedWord"
                >
                </glossary-editor-detail>
            </div>

            <div *ngIf="showAdd" class="card-block">
                <glossary-editor-detail [idx]=""
                                        (saveWithLinkRequest)="saveLinkGlossaryEntry($event)"
                                        (updateRequest)="updateGlossaryEntry($event)"
                                        (cancelRequest)="cancelGlossaryEntry($event)"
                                        (makeDefinitionRequest)="makeDefinition($event)"
                                        [glossaryInfo]="newGlossaryInfo"
                                        [saveInProgress]="saveInProgress"
                                        [selectedWord]="selectedWord"
                >
                </glossary-editor-detail>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="btn-group">
                        <button class="btn btn-success" *ngIf="!searching && searchTerm != '' && !showAdd" (click)="showAddGlossary()">Add new entry for {{searchTerm}}</button>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateEntryVerificationModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Verify to store capitalize entry</h4>
            </div>
            <div class="modal-body">
                <input class="form-label indent" type="radio" name="CapitalizeEntryVerification" [value]="true" [(ngModel)]="saveCapitalizeEntry"> Want to store Capitalize entry
                <br>
                <input class="form-label indent" type="radio" name="CapitalizeEntryVerification" [value]="false" [(ngModel)]="saveCapitalizeEntry" checked="true"> Want to store as Lowercase entry
            </div>

            <div class="modal-footer mt-1">
                <button class="btn btn-sm button-secondary pull-md-right" type="button"
                    (click)="saveVerifiedGlossaryEntry()">
                    Save
                </button>
                <button class="btn btn-sm button-secondary pull-md-right" type="button"
                    (click)="closeCapitalizeVerificationModal()">Close
                </button>
            </div>
        </div>
    </div>
</div>
